import React from 'react';

const IconX = () => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10.3125" cy="10.3281" r="10" fill={'var(--neutral_2)'} />
      <path
        d="M13.6875 6.95312L6.9375 13.7031"
        stroke={'var(--neutral_active'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6875 13.7031L6.9375 6.95312"
        stroke={'var(--neutral_active'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconX;
